export const PENDING = 'pending';
export const APPROVE = 'approve';
export const REJECT = 'reject';
export const CANCEL = 'cancel';
